import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const FormCheckBox = ({
  pref,
  type,
  label,
  name,
  checked,
  errors,
  required,
  onChange
}) => (
  <div
    className={classnames("form-group", {
      "has-error": errors && errors.length > 0
    })}
  >
    <input
      id={`checkbox${name}${pref}`}
      type="checkbox"
      name={name}
      checked={checked}
      style={{ width: "auto", marginRight: 10 }}
      onChange={onChange}
    />

    <label
      className="control-label word-wrap"
      htmlFor={`checkbox${name}${pref}`}
    >
      {label}
      {required ? " *" : ""}
    </label>

    {errors ? <span className="help-block">{errors.join(", ")}</span> : null}
  </div>
);

FormCheckBox.propType = {
  pref: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  errors: PropTypes.array,
  required: PropTypes.bool,
  onChange: PropTypes.func
};

FormCheckBox.defaultProps = {
  required: false
};

export default FormCheckBox;
